import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AdminRouter from './profile/admin/Index';
import UserRouter from './profile/user/Index';

const ADMIN = true;

const Routes = () => (
    <BrowserRouter>{ADMIN ? <AdminRouter /> : <UserRouter />}</BrowserRouter>
);
export default Routes;
